module.exports = __webpack_public_path__ + "static/media/19ESCAP12.1dd67324.jpg";